import styled, { css } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';

type BadgeProps = {
  width: number;
};

export const Badge = styled.img<BadgeProps>(
  props => css`
    max-width: ${props.width}px;
    float: left;
    margin-right: ${layout.spacing.small};

    ${media.smallOnly`
    margin-right: ${layout.spacing.small};
  `}
  `
);
